module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/icon_pin_store_map-e8a56830d504d0df6491e145c93ebb64.svg";